import { createReducer } from '../../helpers/reducers';

import { types } from '../../actions/tara';

const initialState = false;

const setHasMadeIntroduction = (state, action) => action.payload.hasMadeIntroduction;

const handlers = {
  [types.TARA_SET_HAS_MADE_INTRODUCTION]: setHasMadeIntroduction,
};

const hasMadeIntroduction = createReducer(initialState, handlers);

export default hasMadeIntroduction;

export const getTaraHasMadeIntroduction = state => state.tara.hasMadeIntroduction;



// WEBPACK FOOTER //
// ./src/reducers/tara/hasMadeIntroduction.js